class ArtistasLoadMore {
  constructor() {
    this.artistasData = [];
    this.filteredData = [];

    this.itemsPerLoad = 18;
    this.currentIndex = 0;

    this.loadMoreBtn = document.getElementById('load-more-btn');
    this.loadMoreContainer = document.querySelector('.load-more-container');
    this.gridContainer = document.getElementById('artistas-grid-container');

    this.activeFilters = { sortOrder: '' };
  }

  async init() {
    if (!this.gridContainer) {
      console.error('gridContainer não encontrado');
      return;
    }

    this.showLoadingSpinner();

    try {
      const allArtists = await this.fetchPaginatedArtists();
      this.artistasData = allArtists;
      this.filteredData = [...this.artistasData];

      this.filteredData.sort((a, b) => a.titulo.localeCompare(b.titulo));

      this.gridContainer.innerHTML = '';
      this.currentIndex = 0;
      this.renderAllItems();

      const featured = this.artistasData.filter(a => a.emDestaque);
      this.loadFeaturedArtists(featured);

      if (this.loadMoreContainer) this.loadMoreContainer.style.display = 'none';

      document.addEventListener('artistas-filter-change', (e) => {
        this.applyFilters(e.detail || {});
      });
    } catch (error) {
      console.error('❌ Erro ao carregar artistas:', error);
      this.gridContainer.innerHTML = `
        <div class="alert alert-danger text-center py-5">
          <p>Erro ao carregar artistas.</p>
        </div>
      `;
      if (this.loadMoreContainer) this.loadMoreContainer.style.display = 'none';
    } finally {
      this.hideLoadingSpinner();
    }
  }

  showLoadingSpinner() {
    const spinner = document.getElementById('loading-spinner');
    if (spinner) spinner.style.display = 'flex';
  }

  hideLoadingSpinner() {
    const spinner = document.getElementById('loading-spinner');
    if (spinner) spinner.style.display = 'none';
  }

  getPaginateParamKeyFromDom() {
    const nextLink = document.getElementById('artistas-paginate-next');
    const href = nextLink ? nextLink.getAttribute('href') : '';
    if (!href) return null;

    try {
      const url = new URL(href, window.location.origin);
      for (const [key] of url.searchParams.entries()) {
        if (key && key.startsWith('page_')) return key;
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  extractArtistsFromDoc(doc) {
    const elements = doc.querySelectorAll('#artistas-source .artist-data-item, .artist-data-item');
    const artists = [];

    elements.forEach((element) => {
      const titulo = element.dataset.titulo || '';
      const handle = element.dataset.handle || '';
      if (!titulo || !handle) return;

      artists.push({
        id: element.dataset.id || '',
        handle,
        titulo,
        url_page: element.dataset.url || '',
        imagem: element.dataset.imagem || '',
        emDestaque: element.dataset.destaque === 'true',
        letra: titulo.charAt(0).toUpperCase(),
        col_class: 'col-lg-3 col-md-4',
        data_titulo: titulo.toLowerCase().replace(/\s+/g, '-')
      });
    });

    return artists;
  }

  extractArtistsFromHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return this.extractArtistsFromDoc(doc);
  }

  async fetchPaginatedArtists() {
    const allArtists = [];
    const seen = new Set();

    // Página atual: usar DOM real (mais fiável)
    const page1Artists = this.extractArtistsFromDoc(document);
    page1Artists.forEach((a) => {
      const key = a.id || a.handle;
      if (!key || seen.has(key)) return;
      seen.add(key);
      allArtists.push(a);
    });

    const pageParamKey = this.getPaginateParamKeyFromDom();
    if (!pageParamKey) return allArtists;

    const maxPages = 20;
    for (let page = 2; page <= maxPages; page++) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set(pageParamKey, String(page));
      urlObj.searchParams.set('page', String(page));

      console.log(`📄 Buscando página ${page}...`);
      const response = await fetch(urlObj.toString());
      if (!response.ok) break;

      const html = await response.text();
      const artists = this.extractArtistsFromHTML(html);
      if (!artists.length) break;

      let newUnique = 0;
      artists.forEach((a) => {
        const key = a.id || a.handle;
        if (!key || seen.has(key)) return;
        seen.add(key);
        allArtists.push(a);
        newUnique++;
      });

      if (newUnique === 0) break;
    }

    return allArtists;
  }

  loadMoreItems() {
    const endIndex = Math.min(this.currentIndex + this.itemsPerLoad, this.filteredData.length);

    for (let i = this.currentIndex; i < endIndex; i++) {
      this.addEntryToGrid(this.filteredData[i]);
    }

    this.currentIndex = endIndex;

    if (this.loadMoreContainer) {
      this.loadMoreContainer.style.display = this.currentIndex >= this.filteredData.length ? 'none' : 'block';
    }

    document.dispatchEvent(new CustomEvent('artistas-entries-loaded'));
  }

  renderAllItems() {
    // Renderiza tudo de uma vez (sem botão load more)
    this.itemsPerLoad = Math.max(this.itemsPerLoad, this.filteredData.length);
    this.loadMoreItems();
  }

  applyFilters(filters) {
    const sortOrder = (filters && filters.sortOrder) || '';

    this.activeFilters = { sortOrder };
    this.gridContainer.innerHTML = '';
    this.currentIndex = 0;
    this.filteredData = [...this.artistasData];

    if (sortOrder) {
      this.filteredData.sort((a, b) => {
        return sortOrder === 'asc' ? a.titulo.localeCompare(b.titulo) : b.titulo.localeCompare(a.titulo);
      });
    }

    this.renderAllItems();
  }

  addEntryToGrid(entry) {
    const { letra, titulo, imagem, col_class, data_titulo, url_page } = entry;

    let letterSection = this.gridContainer.querySelector(`[data-letter="${letra}"]`);
    if (!letterSection) {
      letterSection = document.createElement('div');
      letterSection.className = 'artistas-letter-section';
      letterSection.setAttribute('data-letter', letra);

      const title = document.createElement('h2');
      title.className = 'h3 mb-5 artistas-letter-title';
      title.textContent = letra;

      const gridRow = document.createElement('div');
      gridRow.className = 'row artistas-letter-grid';
      gridRow.setAttribute('data-letter-grid', letra);

      letterSection.appendChild(title);
      letterSection.appendChild(gridRow);
      this.gridContainer.appendChild(letterSection);
    }

    const entryDiv = document.createElement('div');
    entryDiv.className = `${col_class} col-12 artistas-entry`;
    entryDiv.setAttribute('data-letter', letra);
    entryDiv.setAttribute('data-titulo', data_titulo);

    entryDiv.innerHTML = `
      <div class="agenda-event position-relative pb-sm">
        <div class="image position-relative">
          <a href="${url_page}" title="${titulo}">
            <div class="ratio ratio-1x1">
              ${imagem ? `<img src="${imagem}" class="w-100 img-fluid object-fit-cover" alt="${titulo}">` : ''}
            </div>
          </a>
        </div>
        <div class="info-agenda-event m-0">
          <h3 class="event-title paragraph-lg-generic">
            <a href="${url_page}" class="no-decoration-black stretched-link" title="${titulo}">${titulo}</a>
          </h3>
        </div>
      </div>
    `;

    const letterGrid = letterSection.querySelector('[data-letter-grid]');
    letterGrid.appendChild(entryDiv);
  }

  loadFeaturedArtists(featuredArtists) {
    const wrapper = document.getElementById('artistas-destaque-wrapper');
    if (!wrapper) return;
    if (!featuredArtists || featuredArtists.length === 0) return;

    wrapper.innerHTML = '';

    featuredArtists.forEach((artist) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.innerHTML = `
        <div class="artistas-entry">
          <div class="agenda-event position-relative pb-sm">
            <div class="image position-relative">
              <a href="${artist.url_page}" title="${artist.titulo}">
                <div class="ratio ratio-1x1">
                  ${artist.imagem ? `<img src="${artist.imagem}" class="w-100 img-fluid object-fit-cover" alt="${artist.titulo}">` : ''}
                </div>
              </a>
            </div>
            <div class="info-agenda-event m-0">
              <h3 class="event-title paragraph-lg-generic">
                <a href="${artist.url_page}" class="no-decoration-black stretched-link" title="${artist.titulo}">${artist.titulo}</a>
              </h3>
            </div>
          </div>
        </div>
      `;
      wrapper.appendChild(slide);
    });

    this.initFeaturedSwiper();
  }

  initFeaturedSwiper() {
    setTimeout(() => {
      if (typeof Swiper === 'undefined') return;

      const swiperEl = document.querySelector('.swiperSliderCollectionsPage');
      if (swiperEl && !swiperEl.swiper) {
        new Swiper('.swiperSliderCollectionsPage', {
          slidesPerView: 1,
          spaceBetween: 20,
          navigation: {
            nextEl: '.swiper-button-next-swiperSliderCollectionsPage',
            prevEl: '.swiper-button-prev-swiperSliderCollectionsPage',
          },
          breakpoints: {
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }
        });
      } else if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.update();
      }
    }, 100);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    const instance = new ArtistasLoadMore();
    instance.init();
  });
} else {
  const instance = new ArtistasLoadMore();
  instance.init();
}
